import { useEffect, useState } from 'react';

const useWebView = () => {
  const [isWebView, setIsWebView] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      setIsWebView(params.get('webview') === 'true');
    }
  }, []);

  return isWebView;
};

export default useWebView;
